import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface NetworkStatusStore {
  isNetworkDown: boolean;
  setNetworkDown: () => void;
  setNetworkUp: () => void;
}

export const useNetworkStatusStore = create<NetworkStatusStore>()(
  devtools(
    (set) => ({
      isNetworkDown: false,
      setNetworkDown: () => set({ isNetworkDown: true }),
      setNetworkUp: () => set({ isNetworkDown: false }),
    }),
    { name: "NetworkStatusStore" }
  )
);
